export default __webpack_public_path__ + "static/media/slider-cai-5.437fc4ec.jpg";